var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "sh": "업무분야",
            "tabActive": "건설 엔지니어링",
            "bg": "/images/sub/visual/sv-business.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "text-bg",
    staticStyle: {
      "background-image": "url(/images/sub/business/business-bg.svg)"
    },
    attrs: {
      "tit": "건설 엔지니어링 서비스",
      "titAdd": "Business"
    }
  }, [_c('div', {
    staticClass: "card-rows"
  }, [_c('card-row', {
    attrs: {
      "image": "/images/sub/business/engineering/engineering-img.jpg"
    }
  }, [_c('p', [_vm._v(" 법무법인 태성은 윤영환 대표변호사가 건축시공기술사 자격을 보유하고 있고, 법무법인 태성 이름으로 기술사사무소로 등록되어 있습니다. 외부 기술사사무소를 협력업체로 두고 업무를 진행하는 다른 법무법인과 달리, 법무법인 태성은 법무법인이자 기술사사무소이고 외부 기술사사무소와 협업도 하고 있습니다. ")])]), _c('card-row', {
    attrs: {
      "image": "/images/sub/business/engineering/engineering-img2.jpg"
    }
  }, [_c('p', [_vm._v(" 태성은 아파트 재개발·재건축조합, 입주예정자협의회, 입주자대표회의 등 아파트 입주민들을 위한 법률 기술 분야의 종합적인 서비스를 제공하고 있고, 기술사사무소로서 아파트 안전진단, 감리, 품질점검 등 전문기술분야로도 업무범위를 확대해 나갈 예정입니다. ")]), _c('p', [_vm._v(" 태성은 아파트 생애 주기 전반에 걸쳐 입주민에게 필요한 법률분야 기술분야 모든 서비스를 구축하여, 아파트 입주민들에게 최고의 파트너가 되겠습니다. ")])])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }